import { Chakra } from "@airhelp/react-ui-components";
import PropTypes from "prop-types";

import { trackEvents } from "utils/trackingUtils";

const { Button } = Chakra;

const NavButton = ({ href, title, trackingEvents, dataTestId }) => (
  <Button
    variant="secondary"
    as="a"
    href={href}
    title={title}
    ml={{ lg: 8 }}
    width={{ base: "full", lg: "initial" }}
    order={{ base: "2", md: "1" }}
    onClick={() => trackEvents(trackingEvents)}
    data-testid={dataTestId}
    lineHeight="short"
  >
    {title}
  </Button>
);

export default NavButton;

NavButton.propTypes = {
  href: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  trackingEvents: PropTypes.shape({}),
  dataTestId: PropTypes.string,
};

NavButton.defaultProps = {
  trackingEvents: {},
  dataTestId: "",
};
